import {Fragment} from "react";
import {priceProcessing} from "../../helpers/Processors";

import Col from "../../components/grid/Col";
import VIPBadge from "../../components/UI/VIPBadge";

import './SearchItemCard.css';

const SearchItemCard = (props) => {

    const price = priceProcessing(props.price);
    let priceBlock = <span className='search-card-item__price primary-text'>{price}</span>;
    if (props.discount) {
        const discountPrice = priceProcessing(props.discount);
        priceBlock = (
            <Fragment>
                <span className='search-card-item__price secondary-text'>{discountPrice}</span>
                <span className='search-card-item__price old-price'>{price}</span>
            </Fragment>
        );
    }

    const badge = props.isVIP === '1' ? (
        <span className={'mr-1'}>
            <VIPBadge small />
        </span>
    ) : null;

    return (
        <article className='search-card-item d-flex align-items-center'>
            <Col sm={4} md={3}>
                <img src={props.img} alt={props.img_alt} title={props.img_title} className='w-100' />
            </Col>
            <Col sm={8} md={9}>
                <h3 className='search-card-item__title white-text mb-1'>
                    {badge}
                    {props.title}
                </h3>
                {priceBlock}
            </Col>
        </article>
    );
};

export default SearchItemCard;